import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Currency, OpenCurrencyDialog } from "./dialogs/currencyDialog";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react";
export default class EditCurrencies extends React.Component<EditCurrencyProps, EditCurrencyState> {
    private _gridOptions: any;
    private _translations: string[] = null;

    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            enableDeleteButton: false,
            selectedItem: null
        };
    }

    private _save = () => {
        let url = "Currency/Save";
        HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem })
            .then(result => {
                if (result.Code == 0) {
                    this._getGridData();
                } else {

                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private _delete = () => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "Currency/Delete";
                HTTPService.post<JsonResultClass>(url, { model: this.state.selectedItem })
                    .then(result => {
                        if (result.Code == 0) {
                            this._getGridData();
                        } else {

                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    private _getGridData = () => {
        let url = "Currency/GetAll";
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _createGrid = () => {

        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this._gridOptions) && Helper.hasValue(this._translations);

        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });
            let grid = (
                <Grid data={this.state.gridData} options={this._gridOptions} id="currencyGrid" onSelectionChanged={this._onSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} selectFilter={this.state.selectedItem == null ? null : this.state.selectedItem.Name} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Currency) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this.onEditCurrency(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this.onCreateNewCurrency();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._delete();
        }
    }

    private onEditCurrency = async (sourceCurrency: Currency) => {
        let currency = await OpenCurrencyDialog(sourceCurrency);
        sourceCurrency.Characters = currency.Characters;
        sourceCurrency.Currency = currency.Currency;
        sourceCurrency.Factor = currency.Factor;
        sourceCurrency.From = currency.From;
        sourceCurrency.Name = currency.Name;
        this.setState({ selectedItem: sourceCurrency }, () => this._save());
    }

    private onCreateNewCurrency = async () => {
        let currency = await OpenCurrencyDialog();
        currency.IsNew = true;
        this.setState({ selectedItem: currency }, () => this._save());
    }

    private _onSelectedChange = (dataItem: Currency) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable, selectedItem: dataItem });
        }
    }

    componentDidMount() {
        this._gridOptions = this.props.context.currencyGridOptions;
        this._translations = this.props.context.translations;
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <>
                {grid}
            </>);
    }
};

interface EditCurrencyProps {
    context: ContextGeneralSettingsApp;
}

interface EditCurrencyState {
    enableDeleteButton: boolean;
    selectedItem: Currency;
    gridData: Currency[];
}
